'use client';

import Link from 'next/link';
import type { TextbookTocChapter } from '@/lib/textbook-toc';

type ParentTextbookTocLinksProps = {
  chapter: TextbookTocChapter | null;
  onNavigate?: () => void;
};

export function ParentTextbookTocLinks({
  chapter,
  onNavigate,
}: ParentTextbookTocLinksProps) {
  if (!chapter?.lessons.length) {
    return null;
  }

  return (
    <>
      {chapter.lessons.map((lesson) => (
        <div
          key={lesson.id}
          id={`lesson-${lesson.id}`}
          className="flex items-center justify-between p-4 hover:bg-purple-100/20"
        >
          <div className="flex flex-1 flex-col gap-3 md:mx-10 md:flex-row md:items-center">
            <div className="flex-1">
              <span className="display-text">{lesson.title}</span>
            </div>
            <div className="flex items-center justify-end gap-2 md:min-w-[220px]">
              <Link
                href={lesson.learnPath}
                onClick={onNavigate}
                prefetch={false}
                className="inline-flex rounded-full border border-[#D8E1F0] bg-white px-3 py-1.5 text-xs font-semibold text-[#1F2A44] transition-colors hover:bg-[#F8FBFF]"
              >
                Learn
              </Link>
              <Link
                href={lesson.practicePath}
                onClick={onNavigate}
                prefetch={false}
                className="inline-flex rounded-full border border-[#D8E1F0] bg-white px-3 py-1.5 text-xs font-semibold text-[#1F2A44] transition-colors hover:bg-[#F8FBFF]"
              >
                Practice
              </Link>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
